// @flow

import React from "react";

type Props = {
  size?: number
};

const InfoFilled = ({ size = 18 }: Props) => {
  return (
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        margin: "0 3px"
      }}
    >
      <g clip-path="url(#clip0_1855_1598)">
        <path
          d="M8.99996 -0.00012207C7.21991 -0.00012207 5.47984 0.527723 3.99978 1.51666C2.51973 2.50561 1.36617 3.91123 0.684972 5.55577C0.00377754 7.20032 -0.174454 9.00994 0.172816 10.7558C0.520086 12.5016 1.37726 14.1053 2.63594 15.364C3.89463 16.6227 5.49829 17.4798 7.24413 17.8271C8.98997 18.1744 10.7996 17.9961 12.4441 17.3149C14.0887 16.6337 15.4943 15.4802 16.4832 14.0001C17.4722 12.5201 18 10.78 18 8.99995C17.9975 6.61378 17.0484 4.32607 15.3611 2.63879C13.6738 0.951507 11.3861 0.00245876 8.99996 -0.00012207V-0.00012207ZM9.18746 3.74991C9.40997 3.74991 9.62747 3.81589 9.81248 3.93951C9.99749 4.06313 10.1417 4.23883 10.2268 4.4444C10.312 4.64997 10.3343 4.87617 10.2909 5.0944C10.2474 5.31263 10.1403 5.51309 9.98296 5.67042C9.82563 5.82776 9.62517 5.9349 9.40694 5.97831C9.18871 6.02172 8.96251 5.99944 8.75694 5.91429C8.55137 5.82914 8.37567 5.68495 8.25205 5.49994C8.12843 5.31493 8.06245 5.09742 8.06245 4.87492C8.06245 4.57655 8.18098 4.2904 8.39196 4.07942C8.60294 3.86844 8.88909 3.74991 9.18746 3.74991ZM10.875 13.875H7.87495C7.67603 13.875 7.48527 13.796 7.34461 13.6553C7.20396 13.5147 7.12494 13.3239 7.12494 13.125C7.12494 12.9261 7.20396 12.7353 7.34461 12.5947C7.48527 12.454 7.67603 12.375 7.87495 12.375H8.43745C8.48718 12.375 8.53487 12.3552 8.57004 12.3201C8.6052 12.2849 8.62496 12.2372 8.62496 12.1875V8.81245C8.62496 8.76272 8.6052 8.71503 8.57004 8.67987C8.53487 8.6447 8.48718 8.62495 8.43745 8.62495H7.87495C7.67603 8.62495 7.48527 8.54593 7.34461 8.40528C7.20396 8.26463 7.12494 8.07386 7.12494 7.87494C7.12494 7.67603 7.20396 7.48526 7.34461 7.34461C7.48527 7.20396 7.67603 7.12494 7.87495 7.12494H8.62496C9.02278 7.12494 9.40432 7.28297 9.68562 7.56428C9.96693 7.84559 10.125 8.22712 10.125 8.62495V12.1875C10.125 12.2372 10.1447 12.2849 10.1799 12.3201C10.215 12.3552 10.2627 12.375 10.3125 12.375H10.875C11.0739 12.375 11.2647 12.454 11.4053 12.5947C11.546 12.7353 11.625 12.9261 11.625 13.125C11.625 13.3239 11.546 13.5147 11.4053 13.6553C11.2647 13.796 11.0739 13.875 10.875 13.875Z"
          fill="#0B6DFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_1855_1598">
          <rect width="18.0002" height="18.0002" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default InfoFilled;
